<template>
  <div>
    <BRow class="mb-3">
      <BCol cols="12">
        <BFormTextarea
          id="metaDataBox"
          v-model="salesOrderMetadata"
          :rows="10"
          :readonly="true"
          :value="salesOrderMetadata"
          @change="handleChange"
          label="Metadata"
          outlined
          dense
          required />

        <OmniButtonCollection>
            <!-- Select all button -->
            <OmniButton
              class="mt-2 mr-2"
              @click="selectAll"
              >
              <span class="icon mr-1">
                <FontAwesomeIcon icon="i-cursor" />
              </span>
              <span class="label">
                Alles selecteren
              </span>
            </OmniButton>
            <!-- Copy to clipboard button -->
            <OmniButton
              class="mt-2"
              @click="copyToClipboard"
              >
              <span class="icon mr-1">
                <FontAwesomeIcon icon="copy" />
              </span>
              <span class="label">
                Kopi&#235;ren
              </span>
            </OmniButton>
        </OmniButtonCollection>
      </BCol>
    </BRow>
  </div>
</template>

<script>
import OmniButton           from '@/components/OmniStock/OmniButton.vue';
import OmniButtonCollection from '@/components/OmniStock/OmniButtonCollection.vue';

export default {
  name: "ShowDispatchRequestMetadata",
  components: {
    OmniButton,
    OmniButtonCollection,
  },
  props: {
    salesOrder: {
      type: Object,
      required: true,
      default: {},
    },
  },
  computed: {
    salesOrderMetadata() {
      return this.salesOrder.current_dispatch_requests.reduce((acc, dispatchRequest) => {
        if (dispatchRequest.metadata) {
          acc.push(dispatchRequest.metadata);
        }

        return acc;
      }, []);
    },
  },
  methods: {
    selectAll() {
      document.getElementById('metaDataBox').select();
    },
    copyToClipboard() {      
      const clipboardData = JSON.stringify(this.salesOrderMetadata, null, 2);
      navigator.clipboard.writeText(clipboardData)
        .then(() => {
          this.$alert('Metadata gekopieerd naar klembord.', 'success');
        })
        .catch(err => {
          this.selectAll(); // Select all text in the text field in case the clipboard can't be written to, so the user can still copy the text manually.
          this.$alert('Kopi&#235;ren naar klembord mislukt. Probeer het handmatig.', 'danger');
        });
    },
  },
};
</script>